<template>
  <div class="ten-card">
    <div
      class="ten-card__more"
      v-if="options"
    >
      <ten-dropdown
        trigger-type="click"
        @item-click="onMore"
      >
        <div
          class="ten-card__more-icon"
          :style="{ color: $slots.thumb ? '#fff' : '#333' }"
        >
          <ten-icon icon="more" />
        </div>
        <template v-slot:dropdown>
          <ten-dropdown-menu>
            <ten-dropdown-item
              v-for="(item, $index) in options"
              :key="item.value"
              :index="$index + ''"
            >
              {{ item.text }}
            </ten-dropdown-item>
          </ten-dropdown-menu>
        </template>
      </ten-dropdown>
    </div>
    <div
      class="ten-card__thumb"
      v-if="$slots.thumb"
    >
      <slot name="thumb" />
    </div>
    <div
      class="ten-card__header"
      v-if="$slots.header"
    >
      <slot name="header" />
    </div>
    <div
      class="ten-card__content"
      v-if="$slots.default"
    >
      <slot name="default" />
    </div>
    <div
      class="ten-card__footer"
      v-if="$slots.footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import TenIcon from '../icon/icon.vue';
import TenDropdown from '../dropdown/dropdown.vue';
import TenDropdownMenu from '../dropdown/dropdown-menu.vue';
import TenDropdownItem from '../dropdown/dropdown-item.vue';

export default {
  name: 'TenCard',
  components: {
    TenIcon,
    TenDropdown,
    TenDropdownMenu,
    TenDropdownItem,
  },
  props: {
    /**
     * 更多下拉列表，在不传的情况下，card 右上角的“更多”按钮不会出现 [{ text, value }]
     * @param {Array} options
     * @param {String} options[].text
     * @param {any} options[].value
     */
    options: Array,
  },
  methods: {
    onMore(index) {
      const option = this.options[index];
      /**
       * 更多下拉之后点击某个选项的事件，仅传了 options 的情况下生效
       * @param {Object} option 传入的 options 中，被点中的那一个对象会被作为参数
       */
      this.$emit('option-click', option);
    },
  },
};
</script>
